export default __webpack_public_path__ + "e4b561106f96ed1fa9ba6ae186d89f48.png";